module.exports = __webpack_public_path__ + "img/l1.b794b15a.png";